import { Alert, Card } from 'antd';
import React from 'react';
const ErrorMessage = ({
  message
}) => {
  return <Alert message="Error" description={message} type="error" showIcon data-sentry-element="Alert" data-sentry-component="ErrorMessage" data-sentry-source-file="ErrorMessage.jsx" />;
};
export default ErrorMessage;